import { ReactComponent as IconCheck } from '../../../assets/images/icon-check.svg'

export default function IconCheckGray() {
  return <IconCheck className="[&_path]:fill-gray-3" />
}
